import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
const isFor = ['Asistentes virtuales que quieren dejar de cobrar por hora y pasar a paquetes premium.', 'Mujeres emprendedoras de servicios que se sienten desbordadas por la operativa diaria.', 'Profesionales latinas en USA que buscan escalar su negocio con clientes locales de alto ticket.', 'Quienes ya tienen clientes pero sienten que han perdido su libertad personal en el proceso.'];
const isNotFor = ['Personas que buscan un "empleo de oficina" con horario fijo de 9 a 5.', 'Quienes no están dispuestas a usar herramientas digitales básicas para automatizar su trabajo.', 'Personas que no se sienten cómodas cobrando tarifas profesionales por resultados reales.'];
export function AudienceSection() {
  return <section className="py-20 md:py-32 bg-brand-cream" data-id="element-13">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-14">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-15">
          {/* Who this is for */}
          <FadeIn data-id="element-16">
            <div className="bg-white p-8 md:p-10 rounded-sm shadow-lg border-t-4 border-green-500 h-full" data-id="element-17">
              <h3 className="text-2xl font-bold text-brand-charcoal mb-8 text-center" data-id="element-18">
                Esto ES para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-19">
                {isFor.map((item, index) => <li key={index} className="flex items-start space-x-4" data-id="element-20">
                    <div className="bg-green-100 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-21">
                      <Check className="w-4 h-4 text-green-600" data-id="element-22" />
                    </div>
                    <span className="text-brand-charcoal/80 leading-relaxed" data-id="element-23">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Who this is not for */}
          <FadeIn delay={0.2} data-id="element-24">
            <div className="bg-white p-8 md:p-10 rounded-sm shadow-lg border-t-4 border-red-400 h-full" data-id="element-25">
              <h3 className="text-2xl font-bold text-brand-charcoal mb-8 text-center" data-id="element-26">
                Esto NO es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-27">
                {isNotFor.map((item, index) => <li key={index} className="flex items-start space-x-4" data-id="element-28">
                    <div className="bg-red-100 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-29">
                      <X className="w-4 h-4 text-red-500" data-id="element-30" />
                    </div>
                    <span className="text-brand-charcoal/80 leading-relaxed" data-id="element-31">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}